import { Divider } from '@arco-design/web-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dateFormatRender } from '../FieldsCard';
import styles from './index.module.less';

export const Version = ({ style }: { style?: React.CSSProperties }) => {
  const { t } = useTranslation();
  const [versionInfo, setVersionInfo] = useState<{ version: string; buildTime: Date }>(null);

  const getInfo = () => {
    const infoJson = sessionStorage.getItem('app_version_info');
    if (infoJson) {
      const info = JSON.parse(infoJson);
      setVersionInfo(info);
      return true; // 返回true表示找到了版本信息
    }
    return false; // 返回false表示没有找到版本信息
  };

  useEffect(() => {
    if (!versionInfo) {
      getInfo();
    }

    const timer = setInterval(() => {
      const found = getInfo();
      if (found) {
        clearInterval(timer);
      }
    }, 500);

    return () => clearInterval(timer);
  }, []);

  const { version = '0.0.0', buildTime = new Date() } = versionInfo || {};
  return (
    <div className={styles['version-info']} style={style}>
      <span>
        {t('common:version.with.colon')}
        {version}
      </span>
      <Divider type="vertical" />
      <span>
        {t('common:build.time.with.colon')}
        {dateFormatRender(buildTime)}
      </span>
    </div>
  );
};
